<template>
	<div :class="$style.wrapper">
		<div
			class="d-flex align-center ao-text-secondary-color-700 mb-4"
			style="cursor: pointer"
			@click="toggleShowContent(true)"
		>
			<div class="text-textSecondary700 ao-p2-medium text-uppercase">
				{{ title }}
			</div>
			<v-spacer />
			<span :class="$style['icon-bg']">
				<ao-icon
					iconName="groupOpen"
					size="small"
					:class="[$style.icon, showContent && $style.rotated, 'text-textSecondary700']"
				/>
			</span>
		</div>
		<div>
			<div
				ref="collapse"
				:class="$style.content"
			>
				<slot/>
			</div>
		</div>
		<v-divider />
	</div>
</template>

<script>
export default {
	name: 'PassportCollapse',
	props: {
		title: String,
	},

	data: () => ({
		showContent: true,
	}),

	mounted() {
		this.$refs.collapse.style.maxHeight = `${this.$refs.collapse.scrollHeight}px`
	},

	methods: {
		toggleShowContent() {
			this.showContent = !this.showContent
			this.callMaxHeight()
		},
		callMaxHeight() {
			this.$nextTick(() => {
				if (this.showContent) {
					this.$refs.collapse.style.maxHeight = `${this.$refs.collapse.scrollHeight}px`
				} else {
					this.$refs.collapse.style.maxHeight = '0px'
				}
			})
		},
	},
}
</script>

<style module lang="scss">
.wrapper {
	display: flex;
	flex-direction: column;
	margin-top: 16px;
	width: 100%;

	.icon-bg {
		background: #d9e4ec;
		border-radius: 50%;
		width: 16px;
		height: 16px;
		color: rgb(var(--v-theme-primary));
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.icon {
		height: 10px;
		transition: transform 0.3s ease-out;
		transform: rotate(90deg) scale(1, 1);
		display: flex;

		&.rotated {
			transform: rotate(90deg) scale(-1, 1);
		}
	}

	.content {
		overflow: hidden;
		transition: max-height linear 0.3s;
	}
}
</style>
